import React, { useState, useEffect } from 'react'

import { DotsCircleLoader } from '@reactiveonline/frontend_shared_components'
import ServiceItem from '../../services/ServiceItem'
import ServiceListSlider from '../../services/ServiceListSlider'
import listStyles from '../../services/listStyles'

export default function ServiceList({ item, deviceType, extraData }) {
  const { settings } = item
  const {
    id, classes, viewType, itemsPerRow, itemsLimit, selectionCriterion, items,
    sliderSettings
  } = settings
  const appProps = extraData

  const itemsPerRowClass = getItemsPerRowClass()

  const [entities, setEntities] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect( () => {
    fetchEntities()
  }, [])

  async function fetchEntities() {
    if (selectionCriterion !== 'custom' || items.length) {
      let params = `service_limit=${ itemsLimit }&selected_service_items=${ selectionCriterion }`

      if (selectionCriterion === 'custom') {
        params += `&items=${ JSON.stringify(items) }`
      }

      setLoading(true)

      Rails.ajax({
        type: 'GET',
        url: `${ appProps.selectedServicesPath }?${ params }`,
        dataType: 'json',
        success: result => {
          if (result.items) {
            let fetchedItems = result.items

            if (selectionCriterion === 'custom') {
              fetchedItems = []
              items.forEach( item => {
                const fetchedItem = result.items.find( fetchedItem => fetchedItem.uid === item.uid )
                if (fetchedItem) {
                  fetchedItems.push(fetchedItem)
                }
              })
            }

            setEntities(fetchedItems)
          }
        },
        complete: result => {
          setLoading(false)
        }
      })
    }
  }

  function getItemsPerRowClass() {
    switch (String(itemsPerRow)) {
      case '1':
        return 'one_item'
      case '2':
        return 'two_items'
      case '3':
        return 'three_items'
      case '4':
        return 'four_items'
      case '5':
        return 'five_items'
      case '6':
        return 'six_items'
    }
  }

  return (
    <div
      id={ id || item.id }
      className={ `rb-service-list ${ classes || '' } flex-box flex-wrap` }
    >
      { viewType !== 'slider' && entities.map( (entity, index) => (
        <ServiceItem
          key={ index }
          appProps={ appProps }
          service={ entity }
          servicesPerRowClass={ itemsPerRowClass }
          serviceListStyle='overlay-style'
        />
      ))}

      { viewType === 'slider' &&
        <ServiceListSlider
          appProps={ appProps }
          itemsPerRow={ itemsPerRow }
          sliderSettings={ sliderSettings || {} }
          services={ entities }
          servicesPerRowClass={ itemsPerRowClass }
          serviceListStyle='overlay-style'
        />
      }

      <style dangerouslySetInnerHTML={{ __html: `
        #${ id || item.id } { ${ listStyles(itemsPerRow) }}
      `}}/>

      { loading &&
        <div className='flex-box items-center content-center flex-1'>
          <DotsCircleLoader/>
        </div>
      }
    </div>
  )
}
